export { default as KbSuggestedArticles } from './kb-suggestions';
